import Papa from "papaparse";
import * as XLSX from "xlsx";
import { CSV_SCHEMA } from "./schema";

export function downloadTemplate(): void {
  const headers = CSV_SCHEMA.map((c) => c.field).join(",");
  const example = CSV_SCHEMA.map((c) => c.example).join(",");
  const blob = new Blob([`${headers}\n${example}`], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "products_import_template.csv";
  a.click();
  URL.revokeObjectURL(url);
}

export function parseCSV(
  file: File,
  onComplete: (headers: string[], data: unknown[]) => void,
): void {
  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    complete: (result) => {
      const data = result.data as Record<string, unknown>[];
      onComplete(Object.keys(data[0]), data);
    },
  });
}

export async function parseExcel(
  file: File,
  onComplete: (headers: string[], data: unknown[]) => void,
): Promise<void> {
  const buffer = await file.arrayBuffer();
  const workbook = XLSX.read(buffer);
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const json = XLSX.utils.sheet_to_json(sheet, { defval: "" }) as Record<string, unknown>[];
  onComplete(Object.keys(json[0]), json);
}
